import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDeviceContext } from '@spotahome/ui-library';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import OffersLabel from '@spotahome/ui-library/src/tenant/components/OffersLabel';

import listingOfferShape from '../../shapes/listingOffer';

import RentableUnitPrice from '../RentableUnitPrice';
import ListingSocialButtons from '../ListingSocialButtons';

import './BookNowTitle.scss';

const BookNowTitle = ({
  showPrice = true,
  deviceType,
  listingId,
  showOffersLabel,
  offers,
  appliedOfferValue = null
}) => {
  const { deviceOS } = useDeviceContext();
  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';

  const hasOffers = offers?.length > 0 && showOffersLabel;

  const classes = classNames('booknow-card-title', {
    'booknow-card-title--with-offer-label': true,
    'booknow-card-title--without-social-buttons':
      isListingSimplificationHeaderVariant
  });

  return (
    <div className={classes}>
      {hasOffers && (
        <div className="booknow-card-title__offers-label">
          <OffersLabel
            offers={offers}
            appliedOfferValue={appliedOfferValue}
            clickable
          />
        </div>
      )}
      {!isListingSimplificationHeaderVariant && (
        <div className="booknow-card-title__social-buttons">
          <ListingSocialButtons
            deviceType={deviceType}
            listingId={listingId}
            deviceOS={deviceOS}
          />
        </div>
      )}
      <div className="booknow-card-title__price">
        <RentableUnitPrice showPrice={showPrice} />
      </div>
    </div>
  );
};

BookNowTitle.propTypes = {
  showPrice: PropTypes.bool,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  listingId: PropTypes.string.isRequired,
  showOffersLabel: PropTypes.bool.isRequired,
  offers: PropTypes.arrayOf(PropTypes.shape(listingOfferShape)).isRequired,
  appliedOfferValue: PropTypes.string
};

export default BookNowTitle;
